/** 店铺可自定义的地址一级/二级名称（默认 村 / 组） */
export function normalizeAddressLabel(raw, fallback = '村') {
  const s = String(raw == null ? '' : raw).trim().slice(0, 12)
  return s || fallback
}

export function resolveAddressLabels(info = {}) {
  const village = normalizeAddressLabel(info.label_village, '村')
  const group = normalizeAddressLabel(info.label_group, '组')
  const combo =
    village.length <= 2 && group.length <= 2 ? `${village}${group}` : `${village}/${group}`
  return { village, group, combo }
}

export function formatVillageGroup(row = {}, sep = ' / ') {
  return [row.village, row.group_name].filter(Boolean).join(sep)
}
